// eslint-disable-next-line sonar/function-return-type
export const getRecordId = (id: any): undefined | string | number => {
  if (typeof id === 'number') return id
  if (typeof id === 'string' && id.length)
    return /^\d+$/.test(id) ? Number(id) : id
}
